<template>
  <div>
    <div class="container">
      <h1 class="page-title text-center mt-5">ALL ONLINE CLASS</h1>
      <h2 class="sub-title text-center mb-5" v-html="$t('message.videodetail')"></h2>

      <div class="row mb-3" v-if="!isVideoLoaded">
          <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 6" :key="index">
              <div class="blog-article">
                  <div class="thumbnail mb-3"></div>
                  <div class="paragraph mb-4" style="width: 30%;"></div>
                  <div class="paragraph mb-2" style="width: 100%;"></div>
                  <div class="paragraph" style="width: 80%;"></div>
              </div>
          </div>
      </div>

      <div class="row mb-3" v-if="isVideoLoaded">
          <div class="col-12 col-md-6 col-lg-4" v-for="(video, key) in videos" :key="key">
              <router-link :to="{ name: video.type, params: { slug: video.slug } }">
                  <div class="blog-article">
                      <div class="thumbnail">
                          <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" v-if="video._embedded">
                              <img :data-src="`${video._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :data-srcset="`${video._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                          </div>
                          <!-- /.thumbnail-media -->
                          <div class="article-duration" v-html="video.acf.video_duration"></div>
                      </div>
                      <!-- /.thumbnail -->
                      <div class="blog-desc">
                        <div class="category" v-html="$t('message.video')"></div>
                        <div class="description" v-html="video.title.rendered"></div>
                      </div>
                      <!-- /.blog-desc -->
                  </div>
                  <!-- /.blog-article -->
              </router-link>
          </div>
      </div>
      <!-- /.row -->

      <div class="row mb-5" v-if="totalpages > 1">
        <div class="col text-center">
          <button type="button" :class="['btn', currentpage === index ? 'dark' : 'light', 'mr-3', 'pagination', isButtonLoading ? 'disabled': '']" :disabled="isButtonLoading" @click="getVideos(index)" v-for="(index) in totalpages" :key="index">{{ index }}</button>
        </div>
      </div>
      <!-- /.row -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'EventLanding',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      videos: [],
      isVideoLoaded: false,
      page: null,
      per_page: 12,
      isButtonLoading: true,
      currentpage: 1,
      totalpages: 0
    }
  },
  mounted () {
    document.title = `Videos - ${this.title}`
    const paged = this.$router.history.current.query.paged
    this.getVideos(paged)
  },
  methods: {
    getVideos (page = 1) {
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isButtonLoading = true
      $vm.isVideoLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/video`, {
        params: {
          _embed: true,
          per_page: this.per_page,
          page,
          lang
        }
      })
        .then(res => {
          // let total = 0
          if (res.headers) {
            // total = res.headers['x-wp-total']
            $vm.totalpages = parseInt(res.headers['x-wp-totalpages'])
          }
          if (res.data) {
            $vm.videos = res.data
            $vm.isVideoLoaded = true
            // Add page query
            $vm.$router.push({ query: { paged: page } })
            $vm.currentpage = parseInt(page)
            $vm.page = page + 1
            $vm.isButtonLoading = false
          }
        })
    }
  }
}
</script>
